import { Button, Grid } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { linear_v, linear_item, linear_h } from '../../../libs/linear-layout/LinearLayout';
import Title from '../../../libs/rhf-mui/ui/Title';
import AppMenuButton from '../../components/AppMenuButton';
import { UniForm } from '../../dao/UniForm';
import { UniFunc } from '../../dao/UniFunc';

type Props = {
  CurrUniFunc: UniFunc | null;

  DataList: UniForm[];
  OnRowDoubleClick: (sel: UniForm) => void;

  OnAddUniFormClick: () => void;
}

const DgvUniForm = ({ CurrUniFunc, DataList, OnRowDoubleClick, OnAddUniFormClick }: Props) => {
  return (
    <Grid {...linear_v} >
      <Grid {...linear_item}  >
        {render_dgvUniForm_ActionBar()}
      </Grid>
      <Grid {...linear_item} flex={1} >
        {render_dgvUniForm_DataGrid()}
      </Grid>
    </Grid>
  )

  function render_dgvUniForm_ActionBar() {
    return (<Grid  {...linear_h} alignItems='center' p={1}>
      <AppMenuButton label={<Title variant='subtitle2'> {CurrUniFunc?.getCodeTitle()}</Title>} />
      <Grid {...linear_item} flex={1}>
        {/* blank full width */}
      </Grid>

      <Grid {...linear_item}>
        <Button onClick={OnAddUniFormClick}>新增</Button>
      </Grid>

      <Grid {...linear_item}>

        <Title>...</Title>
      </Grid>
    </Grid>);
  }




  function render_dgvUniForm_DataGrid() {

    const uni_form_columns: GridColDef[] = [
      { field: 'serno', headerName: 'serno', width: 85, editable: true },
      { field: 'guid', headerName: 'guid', width: 150, editable: true },
      { field: 'is_curr', type: 'boolean', headerName: '當前', width: 80, editable: true },
      { field: 'ver', type: 'number', headerName: '版本', width: 80, editable: true },
    ];

    return (
      <DataGrid style={{ width: '100%', backgroundColor: 'white', padding: '12px' }}
        getRowId={(data) => { return data.guid }}
        rows={DataList}
        columns={uni_form_columns}

        pageSize={100} rowsPerPageOptions={[100]} hideFooterSelectedRowCount

        onRowDoubleClick={(params) => {
          const sel_data = (params.row as UniForm);
          OnRowDoubleClick(sel_data);
        }}

      />
    );
  }


}

export default DgvUniForm